// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/flaticon.css
// module id = 2BTa
// module chunks = 0